import React, { ReactNode, useContext, useEffect, useState } from 'react';

import OsPatchInstallContext from '@totem/components/devices/os-patch-installs/osPatchInstallContext';
import { OSPatchInstall } from '@totem/components/devices/os-patch-installs/types';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { DEVICES_ENDPOINT } from '@totem/utilities/endpoints';

type Props = {
  id: string;
  children?: ReactNode;
};

const OSPatchInstallsContainer = ({ id, children }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const [refreshData, setRefreshData] = useState<boolean>(true);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [data, setData] = useState<OSPatchInstall[]>([]);
  const [action, setAction] = useState<string>('');
  const [actionItem, setActionItem] = useState<OSPatchInstall>(null);

  useEffect(() => {
    if (refreshData) {
      setRefreshData(false);

      setIsLoading(true);

      const uri = `${DEVICES_ENDPOINT}/${id}/os-patch-installs`;

      fetch(uri, {
        method: 'GET',
        headers: new Headers({
          Authorization: `Bearer ${getApiToken()}`,
        }),
      })
        .then((res) => res.json())
        .then((result: OSPatchInstall[]) => {
          setData(result);
        })
        .then(() => {
          setIsLoading(false);
        });
    }
  }, [id, refreshData, getApiToken]);

  const handleAction = (newAction: string, item: OSPatchInstall) => {
    switch (newAction) {
      default:
        setAction(newAction);

        setActionItem(item);
    }
  };

  return (
    <OsPatchInstallContext.Provider
      value={{
        deviceId: id,
        loading: isLoading,
        data,
        action,
        actionItem,
        onAction: handleAction,
      }}
    >
      <div>{children}</div>
    </OsPatchInstallContext.Provider>
  );
};

export default OSPatchInstallsContainer;
